import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { GlobalService } from '@common/global';
import { Subscription } from 'rxjs/Subscription';
import 'rxjs/add/operator/map';
import * as _ from 'lodash';
@Injectable({
  providedIn: 'root'
})
export class ApiService {
  constructor(private _global: GlobalService, private http: HttpClient) {
  }
  public handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
  };

  public call(url, params) {
    //  console.log("Calling api with obj", params);
    let token = this._global.getToken();
    
    if (_.isEmpty(token)) {
      if(params["updates"]){
      Object.entries(params["updates"]).forEach(([key, value]) => {
        if (value["param"] == "token") {
          token = value["value"];
        }
      });
    }
    }

    //   console.error('Token:', token);

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'my-auth-token',
        'Accept': 'application/json',
        'Cache-Control': 'no-cache',
        'max-age': '0',
        'must-revalidate': 'true',
        'x-forwarded-for': '1',
        's-maxage': '0',
        'token': "" + token + ""
      })
    };

    // console.log("making call to ", url);
    //  console.log("making call with httpOptions ", JSON.stringify(httpOptions));
    return this.http.post('/api/' + url, params, httpOptions).map(data => {
      // console.log("ApiProvider:call response received", data);
      if (this._global.getVal(data, 'status', '') == '407') {
        // console.log("status=407---->", data);
        return {};
      } else if (this._global.getVal(data, 'status', '') == '401') {
        // console.log("status=407---->", data);
        return {};
      } else if (this._global.getVal(data, 'status', '') == '200') {
        // console.log("status=200---->", data);
        return data;
      }
      else if (this._global.getVal(data, 'response', '') == '') {
        //  console.log("status=OTHER1---->", data);
        if (url == 'apidoc') {
          return data;
        } else {
          return {};
        }
      } else {
        // console.log("status=OTHER2---->", data);
        return data;
      }
    });
  }

  public getMemberSession() {
    // console.log('Inside getMemberSession');
    if (this._global.isLocalStorage) {
      // console.log('Inside getMemberSession: 1');
      let session = this._global.getSession();
      if (session != null) {
        //console.log('Inside getMemberSession: session=', session);
        var isMember = session[this._global.SESSION_KEY]['isMember'];
        var isAnonymousUser = session[this._global.SESSION_KEY]['anonymousUser'];
        var isLocalStorage;
        //console.log('Inside getMemberSession: isMember=', isMember);
        // console.log('Inside getMemberSession: isAnonymousUer=', isAnonymousUser);
        return new Observable<{}>(observer => {
          const subscription = new Subscription();
          return subscription;
        }
        );
      }
      else {
        //  console.log('Inside getMemberSession: 2');
        let params = new HttpParams();
        params = params.append('domainName', this._global.DOMAIN_NAME);
        params = params.append('sess_cookie', this._global.getRandomUuid());
        params = params.append('token', this._global.getToken());
        //  console.log('Inside getMemberSession: params', params);
        return this.call('member/anonymous', params);
      }
    }
  }
}
